module.exports = __webpack_public_path__ + "img/logo-menu-branco.f3f32fe3.png";